import React from 'react'
import NavbarLogin from "../components/navbarLogin/NavbarLogin";
import ResetCard from '../components/ResetPasswordCard/resetCard';

function ResetPasswordPage() {
  return (
    <div>
        <NavbarLogin />
        <ResetCard/>
    </div>
  )
}

export default ResetPasswordPage